// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"BlogDetailPage","460":"HomePage"}[chunkId] + "-legacy." + {"177":"5b6a7318","460":"0b42a759"}[chunkId] + ".js";
};